// @flow

import { css } from 'styled-components';

import cinematicRevealVerticalKeyframes from '../../keyframes/cinematicRevealVerticalKeyframes';

export default css`
  opacity: 0;
  animation: ${cinematicRevealVerticalKeyframes} 0.4s ease-in-out;
  animation-delay: ${props => props.delay}s;
  animation-fill-mode: forwards;
`;
